/**
 * Reine Hilfen für die Anspruchsteile der Mängel (tri-server docs/claims.md).
 */

import type { Limitation } from "../../ClaimsAPI";

/**
 * `YYYY-MM-DD` → `TT.MM.JJJJ`, ohne `new Date(string)`: Das läse den Tag als UTC-Mitternacht und
 * zeigte westlich von Greenwich den Vortag — ein Verjährungsende darf nicht um einen Tag wandern.
 */
export const formatLegalDate = (date: string | null | undefined): string => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date ?? "");

  return match ? `${match[3]}.${match[2]}.${match[1]}` : "—";
};

export type WarrantyUrgency = "critical" | "soon" | "calm" | null;

/** Dieselben Stufen wie das Radar (30/60/90 Tage): bis 30 kritisch, bis 90 bald. */
export const urgencyOfDays = (remainingDays: number | null | undefined): WarrantyUrgency => {
  if (remainingDays == null) return null;
  if (remainingDays <= 30) return "critical";
  if (remainingDays <= 90) return "soon";

  return "calm";
};

export const warrantyUrgency = (limitation: Limitation | null | undefined): WarrantyUrgency =>
  limitation?.state === "running" ? urgencyOfDays(limitation.remainingDays) : null;

/** Ist der Mangel ein Anspruchsfall? Wie `isClaimActive` im Server. */
export const isClaimCase = (defect: { claimStatus?: string | null; status?: string }): boolean =>
  defect.claimStatus != null && !["noClaim", "closed"].includes(defect.claimStatus) && defect.status !== "discarded";
